<template>
  <div class="openLayout">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'openLayout',
  data(){
    return {

    }
  },
  created(){

  },
  mounted(){




  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
.openLayout{
  position: relative;
  width: 100%;
  height: 100%;
}
</style>